module.exports = new __parcel__URL__("workspot.9769fd16.png").toString();